export { default } from './LayoutFooterBrand';
